module.exports = __webpack_public_path__ + "static/img/2.34e77ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/5/1/eng/2.png
// module id = B6+K
// module chunks = 0